import { Earnings } from "./Earnings";
import { PaymentRequests } from "./PaymentRequests";

import "./payments.scss";

export function Payments() {
	return (
		<div className="right-column-content-container">
			<div className="payments-container">
				<Earnings />
				<PaymentRequests />
			</div>
		</div>
	);
}
